import { Box, styled } from "@mui/material"

export const PrimaryTile = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.mockup.primary95}`,
}))
